<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';

	interface Props {
		title?: string | undefined;
		class?: string;
	}

	let { title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} width="60" height="60" viewBox="0 0 80 80" {...rest}>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M40 70C56.5685 70 70 56.5685 70 40C70 23.4315 56.5685 10 40 10C23.4315 10 10 23.4315 10 40C10 56.5685 23.4315 70 40 70ZM40 65.7143C54.2016 65.7143 65.7143 54.2016 65.7143 40C65.7143 25.7984 54.2016 14.2857 40 14.2857C25.7984 14.2857 14.2857 25.7984 14.2857 40C14.2857 54.2016 25.7984 65.7143 40 65.7143Z"
		fill="#EF4444"
	/>
	<path
		d="M38.6667 29.8333C38.6667 29.0049 39.3382 28.3333 40.1667 28.3333C40.9951 28.3333 41.6667 29.0049 41.6667 29.8333V43.8333C41.6667 44.6618 40.9951 45.3333 40.1667 45.3333C39.3382 45.3333 38.6667 44.6618 38.6667 43.8333V29.8333Z"
		fill="#EF4444"
	/>
	<path
		d="M38.6667 50.8327C38.6667 50.0043 39.3382 49.3327 40.1667 49.3327C40.9951 49.3327 41.6667 50.0043 41.6667 50.8327C41.6667 51.6611 40.9951 52.3327 40.1667 52.3327C39.3382 52.3327 38.6667 51.6611 38.6667 50.8327Z"
		fill="#EF4444"
	/>
</SvgWrapper>
